import { connect } from "react-redux"
import { compose, lifecycle, withProps, withState, withHandlers } from "recompose"

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as OrgSelectors from 'app/modules/org/selectors'
import * as OrgActions from 'app/modules/org/actions'
import * as EmbedSelectors from 'app/modules/embed/selectors'
import * as SegmentSelectors from 'app/modules/segment/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import * as SegmentActions from 'app/modules/segment/actions'
import { EmailPreviewView } from 'app/modules/playbook/constants'

import { SequencePreview } from './component'
import { bindActionCreators } from "redux"


const mapStateToProps = state => {
  const sequence = PlaybookSelectors.sequence(state)
  return {
    sequence,
    currentUserId: UserSelectors.currentUserId(state),
    currentUserName: UserSelectors.currentUserName(state),
    currentUserEmail: UserSelectors.currentUserEmail(state),
    emails: PlaybookSelectors.emails(state),
    isMarketingSequencePlaybook: PlaybookSelectors.getIsMarketingSequencePlaybook(state),
    isOutboundSequencePlaybook: PlaybookSelectors.getIsOutboundSequencePlaybook(state),
    marketingEmailLayout: PlaybookSelectors.marketingEmailLayout(state),
    orgUsers: UserSelectors.currentOrgUsersAlphabetical(state),
    orgName: OrgSelectors.orgName(state),
    orgLogoUrl: OrgSelectors.orgLogoUrl(state),
    orgTwitterUrl: EmbedSelectors.orgTwitterLink(state),
    orgLinkedinUrl: EmbedSelectors.orgLinkedinLink(state),
    orgFacebookUrl: EmbedSelectors.orgFacebookLink(state),
    orgAddress: EmbedSelectors.orgAddress(state),
    backgroundColor: EmbedSelectors.backgroundColor(state),
    showBranding: EmbedSelectors.getOrgShowBranding(state),
    userListIds: SegmentSelectors.segments(state),
    isTemplateContactPreviewLoading: PlaybookSelectors.isTemplateContactPreviewLoading(state),
    getEmailTemplate: emailId => PlaybookSelectors.getRenderedEmailPreview(state, emailId),
    sequenceSenderEmailOverride: PlaybookSelectors.sequenceSenderEmailOverride(state),
    sequenceSendFromOverride: PlaybookSelectors.sequenceSendFromOverride(state),
    sequenceDynamicSendAttribute: PlaybookSelectors.sequenceDynamicSendAttribute(state),
    senderEmailOverride: PlaybookSelectors.senderEmailOverride(state),
    sendFromOverride: PlaybookSelectors.senderEmailOverride(state),
    dynamicAccountSendAttribute: PlaybookSelectors.dynamicAccountSendAttribute(state),
    hasLimitedContactsMktEmail: OrgSelectors.hasLimitedContactsMktEmail(state),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchSegmentList: SegmentActions.fetchSegmentList,
      fetchRenderedEmailPreview: PlaybookActions.fetchDataPreviewSequenceEmail,
      hasLimitedContactsMktEmail: OrgActions.hasLimitedContactsMktEmail,
    },
    dispatch
  )
})

const replaceCalendarTokenForTemplate = template => (
  template && template.replace(`<div><span class="drift-editor-tag mceNonEditable">{{ sender.upcoming_availability }}</span></div>`, `<div class="calendar-injection"><span class="drift-editor-tag mceNonEditable calendar-preview"></span></div>`)
)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const {
        actions: { fetchRenderedEmailPreview, fetchSegmentList, hasLimitedContactsMktEmail },
        currentUserEmail,
        currentUserId,
        emails,
        orgUsers,
        sequenceSenderEmailOverride,
       } = this.props

      fetchSegmentList()
      hasLimitedContactsMktEmail()

      emails.map(({ id, senderEmailOverride }) => {
        // Find the sender for each email - account for full sequence override or individual email override.
        const senderEmail = senderEmailOverride || sequenceSenderEmailOverride || senderEmailOverride || currentUserEmail
        // If navigating directly to the preview page, orgUsers will be empty, so default to the current user.
        const sender = orgUsers.toJS().find(user => user.email === senderEmail)
        fetchRenderedEmailPreview({ emailId: id, userListIds: [], userId: (sender && sender.id) || currentUserId })
      })
    },
  }),
  withProps(props => ({
    userListIdOptions: props.userListIds
      .map(segment => Object.assign(segment.toJS(), { label: segment.name, value: segment.id }))
      .toJS(),
  })),
  withState('selectedPreview', 'changeSelectedPreview', EmailPreviewView.DEFAULTS),
  withState('selectedUserListOption', 'changeUserListOption', undefined),
  withProps(props => {
    const getDynamicAttr = (email) => email.get('dynamicAccountSendAttribute') || props.sequenceDynamicSendAttribute || props.dynamicAccountSendAttribute
    return {
      getIsDynamicSender: (email) => !!getDynamicAttr(email),
      getPreviewMessage: (emailId, message) => props.selectedPreview === EmailPreviewView.TEMPLATE ? message : replaceCalendarTokenForTemplate(props.getEmailTemplate(emailId)),
      getFromName: (email) => !!getDynamicAttr(email) ? getDynamicAttr(email) : email.get('sendFromOverride') || props.sequenceSendFromOverride || props.sendFromOverride || props.currentUserName,
      getFromEmail: (email) => !!getDynamicAttr(email) ? null : email.get('senderEmailOverride') || props.sequenceSenderEmailOverride || props.senderEmailOverride || props.currentUserEmail,
    }
  }),
  withHandlers({
    onRenderedPreviewClick: props => () => {
      props.changeSelectedPreview(EmailPreviewView.RENDERED_DATA)
    },
    onDefaultPreviewClick: props => () => {
      const { changeSelectedPreview, emails, actions: { fetchRenderedEmailPreview }} = props
      changeSelectedPreview(EmailPreviewView.DEFAULTS)
      emails.map(({ id }) => fetchRenderedEmailPreview({ emailId: id, userListIds: []}))
    },
    onTemplatePreviewClick: props => () => {
      props.changeSelectedPreview(EmailPreviewView.TEMPLATE)
    },
    handleChangeUserListOption: props => option => {
      const { changeUserListOption, changeSelectedPreview, emails, actions: { fetchRenderedEmailPreview }} = props
      changeUserListOption(option)
      emails.map(({ id, campaignId }) => fetchRenderedEmailPreview({ emailId: id, userListIds: [option.id], campaignId }))
      changeSelectedPreview(EmailPreviewView.RENDERED_DATA)
    },
    onRefreshPreviewClick: props => () => {
      const { selectedUserListOption, changeSelectedPreview, emails, actions: { fetchRenderedEmailPreview }} = props
      if (selectedUserListOption)
        emails.map(({ id, campaignId }) => fetchRenderedEmailPreview({ emailId: id, userListIds: [selectedUserListOption.id], campaignId }))
      changeSelectedPreview(EmailPreviewView.RENDERED_DATA)
    },
  }),
)(SequencePreview)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SequencePreview/index.js